import moment from "moment";
import React from 'react'
const json = {
    admission_date: moment(new Date()).format("DD-MM-YYYY"),
    discharge_date: moment(new Date()).format("DD-MM-YYYY"),
    discharge_status: '',
    discharge_type: '',
    history: '',
    chief_complaint: '',
    hr: '',
    rr: '',
    bp_s: '',
    bp_d: '',
    bt: '',
    sat: '',
    other: '',
    gcs_e: '',
    gcs_v: '',
    gcs_m: '',
    inv_eFAST: '',
    inv_p_cxr: '',
    inv_other: '',
    management: '',
    operation: '',
    findings: '',
    principal_diagnosis: '',
    other_problems: '',
    hosital_course: '',
    complication: '',
    home_medications: '',
    appointment: '',
    iss_head: '',
    iss_chest: '',
    iss_external: '',
    iss_face: '',
    iss_abdomen: '',
    iss_extremity: '',
    iss_rr: '',
    iss:0,
    rts:'',
    mechanism_injury: '',
    patient_id: '',
    visit_id  :'',
    admission_id: '',
    discharge_id : '',
    hn:'',
    an:'',
    triss:'',
    blood_group:'',
    rh: '',
    dc_chief_complaint :'',
    discharge_rr:'',
    iss_search:'',
    ward:'',
    staff_name :'',
    staff_id :'',
    resident_name :'',
    division :'Trauma',
    record_name :'',
    recode_code :'',
    record_datetime :  moment(new Date()).format("DD-MM-YYYY H:mm"),
    age:0




}

export default json;
